import { Action } from '@ngrx/store';
import { EntriesState } from '../../../../core/features/store/base-feature-state';
import { AssignedShipTo, AssignedShipToPage } from '../../../../core/model/address.model';
import { getAvailableShipToUniqueId } from '../../utils/available-ship-to-utils';
import { SoldToActions } from '../actions';
import { AvailableShipTosActionTypes } from '../actions/sold-to-available-ship-tos.action';

export const initialState: EntriesState<AssignedShipTo> = {};

export function reducer(state = initialState, action: Action): EntriesState<AssignedShipTo> {
  switch (action.type) {
    case AvailableShipTosActionTypes.LoadAvailableShipTosSuccess: {
      const availableShipTosSuccess = <SoldToActions.LoadAvailableShipTosSuccess>action;
      const payload: AssignedShipToPage = availableShipTosSuccess.payload;

      const results = payload.results;

      return results.reduce(
        (entities: { [id: string]: AssignedShipTo }, entry: AssignedShipTo) => {
          return {
            ...entities,
            [getAvailableShipToUniqueId(entry)]: entry,
          };
        },
        {
          ...state,
        }
      );
    }
    default:
      return state;
  }
}
